import React, { useEffect, useRef } from "react"
import { ElementLoader } from "@ciq/shared/components/element_loader"
import { SplitLayout } from "@ciq/shared/components/split_layout"
import { useAnalyticsContext } from "@ciq/shared/contexts/AnalyticsContext"

import { MapLeftPane } from "./components/leftPane/view"
import { Overlay } from "./components/overlays/overlay"
import { MapRightPane } from "./components/rightPane/view"
import { Map } from "./components/map/view"

import { MapViewDataProvider, useMapViewData } from "./hooks/map_view_data"

export function MapView(props) {
  const { children } = props

  return (
    <MapViewDataProvider>
      <View>{children}</View>
    </MapViewDataProvider>
  )
}

function View(props) {
  const { view } = useMapViewData()
  const { map, isOptedIn, isSetup } = useAnalyticsContext()
  const hasTrackedRef = useRef(false)
  const { hasResource, isHidingLeftPane, toggleLeftPane, isHidingRightPane, toggleRightPane } = view
  const { children } = props

  useEffect(() => {
    if (hasTrackedRef.current) return
    if (!isOptedIn || !isSetup) return

    hasTrackedRef.current = true
    map.trackMapViewLoaded()
  }, [map, isOptedIn, isSetup])

  return (
    <>
      <h1 className="sr-only">Map</h1>
      <ElementLoader elementId="map-content">
        <Map />
      </ElementLoader>
      <SplitLayout
        hasDetailResource={hasResource}
        leftPaneClassName="map-split-layout"
        isHidingLeftPane={isHidingLeftPane}
        toggleLeftPane={toggleLeftPane}
        rightPaneClassName="map-split-layout"
        isHidingRightPane={isHidingRightPane}
        toggleRightPane={toggleRightPane}
        showHideButtons={true}
      >
        <MapLeftPane />
        <Overlay />
        <MapRightPane>{children}</MapRightPane>
      </SplitLayout>
    </>
  )
}
